export default "__VITE_ASSET__BCadlzBk__"